import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37deb904"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loader" }

import { computed, withDefaults } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CircleLoader',
  props: {
    borderWidth: { default: 5 }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "3d4221d0": (width.value)
}))

const props = __props;

const width = computed(() => {
  return `${props.borderWidth}px`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1))
}
}

})